module.exports = __webpack_public_path__ + "img/dianzu2.1a3ec31a.svg";